import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationStateService {
  private readonly unreadCount$ = new BehaviorSubject<number>(0);
  public readonly unreadCount = this.unreadCount$.asObservable();

  public setUnreadCount(count: number): void {
    this.unreadCount$.next(count);
  }

  public get currentCount(): number {
    return this.unreadCount$.getValue();
  }
}
